import React, {useState} from "react";

import {Grid} from "@mui/material";
import {CompPartitionHeader} from "../../../components/PartitionHeader";
import {CompTextField} from "../../../components/TextField";
import * as PropTypes from "prop-types";
import {ButtonSpacer} from "../../../components/ButtonSpacer";
import {CompListTree} from "../../../components/ListTree";
import {generateKey, isFunction} from "../../../utils";
import {useTranslation} from "react-i18next";
import {selectButtonType} from "../../../components/utils";
import {CompDropdown} from "../../../components/Dropdown";
import {connect} from "react-redux";
import {
    deleteFeedback,
    getFeedbackReport,
    getLocationTypeOptions,
    listFeedback,
    recreateLinksForFunction
} from "../../function/function.actions";
import {CompTextFieldNew} from "../../../components/newComponents/TextField";
import {ButtonPrimary} from "../../../components/newComponents/ButtonPrimary";
import CustomSnackbar from "../../../components/CustomSnackbar";
import {recreateLinksForLocation} from "../location.actions";


const LocationFormComponent = ({locationTypes,
                                   props}) => {
    const {
        label,
        onChange,
        editorActivated,
        actionButtons,
        selectedLocation = {},
        selectedMunicipality = {},
        fieldErrors = {},
        organizationTree = [],
        recreateLinksForLocation,
        ...componentProps
    } = props;

    const {t} = useTranslation('translation');

    const selectOrganization = (row, isAddAction/*, index */) => {
        let value = null;
        if (isAddAction) {
            value = row.id;
        }
        const data = {
            target: {
                ...componentProps,
                value: value,
                name: 'organizationId',
            },
        };
        if (isFunction(onChange)) {
            onChange(data);
        }
    }

    const handleChange = (event) => {
        if (isFunction(onChange)) {
            onChange(event)
        }
    };

    const handleClick = (event, callback) => {
        event.preventDefault()
        callback(event, selectedLocation);
    };

    let componentActionButtons = [];
    if (actionButtons) {
        actionButtons.forEach(function (button) {
            const key = generateKey('locEditButton');
            selectButtonType(button, componentActionButtons, key, handleClick);
        });
    }

    const [feedbackCodeOpen, setFeedbackCodeOpen] = useState(false)

    const generateLinks = (event, id) => {
        event.preventDefault();
        setFeedbackCodeOpen(true)
        recreateLinksForLocation(id);
    }

    const handleAlertClose = () => {
        setFeedbackCodeOpen(false)
    };

    const getQRLink = () => {
        return "/feedback/"+selectedLocation.code+"-preview";
    }

    return (
        <form noValidate autoComplete="off" className={"location-container"}>
            <Grid container>
                <Grid size={12}>
                    <Grid container spacing={0}>
                        <Grid size={12}>
                            <CompPartitionHeader text={label}/>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Grid container spacing={0}>
                        <Grid size={12}>
                            <CompTextField
                                label={`${t('common.municipality')}*`}
                                value={selectedMunicipality.name}
                                disabled={true}
                                error={fieldErrors.name}
                                name="municipality"
                                onChange={handleChange}/>
                        </Grid>
                        <Grid size={12}>
                            <CompTextField
                                value={selectedLocation.name}
                                onChange={handleChange}
                                disabled={!editorActivated}
                                error={fieldErrors.name}
                                name="name"
                                label={`${t('location.name')}*`}
                            />
                        </Grid>
                        <Grid size={12}>
                            <CompTextField
                                label={`${t('location.post_code')}`}
                                value={selectedLocation.postCode}
                                disabled={!editorActivated}
                                error={fieldErrors.postCode}
                                name="postCode"
                                onChange={handleChange}/>
                        </Grid>
                        <Grid size={12}>
                            <CompDropdown
                                label={`${t('location.location_type')}*`}
                                selectedValue={selectedLocation.locationTypeId?selectedLocation.locationTypeId:""}
                                rows={getLocationTypeOptions(t, locationTypes)}
                                disabled={!editorActivated}
                                name="locationTypeId"
                                error={fieldErrors.locationTypeId}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item size={{xs: 12, sm: 12}} sx={{display: 'flex', gap: '2vh'}}>
                            <CompTextFieldNew
                                label={t('function.feedback_code')}
                                isLabelShrink={true}
                                value={selectedLocation.code}
                                disabled={true}
                                name="feedbackLink"
                            />
                            <ButtonPrimary
                                key={'generate_new_code'}
                                className="generate-new-link-btn"
                                onClick={e => generateLinks(e, selectedLocation.id)}
                                disabled={!editorActivated}>
                                {t('function.generate_links')}
                            </ButtonPrimary>
                            <CustomSnackbar open={feedbackCodeOpen} onClose={handleAlertClose} severity="success" message={'Uusi palautekoodi luotu!'} />
                        </Grid>
                        { selectedLocation.code &&
                            (
                            <Grid item size={{xs: 12, sm: 12}} sx={{display: 'flex', gap: '2vh'}}>
                                <ButtonPrimary className='qr_code-btn' onClick={() => window.open(getQRLink())} sx={{cursor: 'pointer', whiteSpace: "nowrap"}}>
                                    {t('function.feedback_link')}
                                </ButtonPrimary>
                            </Grid>
                            )
                        }
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Grid container spacing={0}>
                        <Grid size={12}>
                            <CompListTree
                                onSelect={selectOrganization}
                                rows={organizationTree}
                                selectedRows={[selectedLocation.organizationId]}
                                disabled={!editorActivated}
                                error={fieldErrors.organizationId}
                                name="organizationId"
                                wholeTreeOpen={true}
                                keyColumn={'id'}
                                valueColumn={'name'}>
                                {t('common.organization')}
                            </CompListTree>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Grid container spacing={0}>
                        <Grid size={12}>
                            <CompTextField
                                label={t('location.description')}
                                value={selectedLocation.description}
                                disabled={!editorActivated}
                                error={fieldErrors.description}
                                name="description"
                                multiline
                                rows={6}
                                onChange={handleChange}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Grid
                        container spacing={1}
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        className={'bottom-button-container'}>
                        <Grid className={'align-right'} size={12}>
                            <ButtonSpacer>
                                {componentActionButtons}
                            </ButtonSpacer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}

LocationFormComponent.propTypes = {
    editorActivated: PropTypes.bool,
    onChange: PropTypes.func,
    selectedLocation: PropTypes.object,
    selectedMunicipality: PropTypes.object,
    actionButtons: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
    // return state;
    return {
        locationTypes: state.root.locationTypes,
        props: ownProps
    }
}

const LocationForm = connect(mapStateToProps)(LocationFormComponent);

export {LocationForm};